import api from '../library/axios';

export default {
  getCustomFeature(workspace_id) {
    return api({
      method: 'get',
      url: `/api/custom-features/${workspace_id}`,
    });
  },
  updateAgentCustomFeature(workspace_id, {
    bot,
    my_group,
    mine,
    all,
  }) {
    return api({
      method: 'patch',
      url: `/api/custom-features/update-agent/${workspace_id}`,
      data: {
        bot,
        my_group,
        mine,
        all,
      },
    });
  },
  updateMakerChecker(workspace_id, {
    status,
    maker,
    checker,
  }) {
    return api({
      method: 'patch',
      url: `/api/custom-features/update-maker-checker/${workspace_id}`,
      data: {
        status,
        maker,
        checker,
      },
    });
  },
  updateSla(workspace_id, {
    status,
    ticket,
    call,
  }) {
    return api({
      method: 'patch',
      url: `/api/custom-features/update-sla/${workspace_id}`,
      data: {
        status,
        ticket,
        call,
      },
    });
  },
};
